import { FORM_VALIDATOR_TYPES } from '../constants';
import { IEventForm } from '../interface/eventModel';

export const EVENT_DETAILS_INITIAL_STATE: IEventForm = {
  eventName: {
    value: '',
    validator: FORM_VALIDATOR_TYPES.TEXT,
    isRequired: true,
    error: null,
    disable: false,
    maxLength: 150,
  },
  eventType: {
    value: null,
    validator: FORM_VALIDATOR_TYPES.OBJECT,
    isRequired: true,
    error: null,
    disable: false,
  },
  startDate: {
    value: null,
    validator: FORM_VALIDATOR_TYPES.DATE,
    isRequired: true,
    error: null,
    disable: false,
  },
  endDate: {
    value: null,
    validator: FORM_VALIDATOR_TYPES.DATE,
    isRequired: false,
    error: null,
    disable: true,
  },
  consentDeadline: {
    value: null,
    validator: FORM_VALIDATOR_TYPES.DATE,
    isRequired: false,
    error: null,
    disable: false,
  },
  description: {
    value: '',
    validator: FORM_VALIDATOR_TYPES.TEXT,
    isRequired: false,
    error: null,
    disable: false,
    maxLength: 500,
  },
  sendNotification: {
    value: false,
    validator: null,
    isRequired: false,
    error: null,
    disable: false,
  },
  needConsent: {
    value: false,
    validator: null,
    isRequired: false,
    error: null,
    disable: false,
  },
  invoiceTemplate: {
    value: null,
    validator: null,
    isRequired: false,
    error: null,
    disable: true,
  },
  // Paid-event invoice window. Validated manually in onSubmit (only when a fee
  // template is selected), so the generic formValidator skips these.
  invoiceStartDate: {
    value: null,
    validator: null,
    isRequired: false,
    error: null,
    disable: true,
  },
  invoiceEndDate: {
    value: null,
    validator: null,
    isRequired: false,
    error: null,
    disable: true,
  },
  forAllOrganization: {
    value: false,
    validator: null,
    isRequired: false,
    error: null,
    disable: true,
  },
  curriculums: {
    value: null,
    validator: null,
    isRequired: false,
    error: null,
    disable: true,
  },
  grades: {
    value: null,
    validator: null,
    isRequired: false,
    error: null,
    disable: true,
  },
  classrooms: {
    value: null,
    validator: null,
    isRequired: false,
    error: null,
    disable: true,
  },
  attachments: {
    value: [],
    validator: FORM_VALIDATOR_TYPES.ARRAY,
    isRequired: false,
    error: null,
    disable: false,
  },
  startTime: {
    value: '',
    validator: null,
    isRequired: false,
    error: null,
    disable: false,
  },
  endTime: {
    value: '',
    validator: null,
    isRequired: false,
    error: null,
    disable: false,
  },
  participants: {
    value: null,
    validator: null,
    isRequired: false,
    error: null,
    disable: false,
  },
};
